import { render, staticRenderFns } from "./certificate_204.vue?vue&type=template&id=14b7b656&scoped=true&"
import script from "./certificate_204.vue?vue&type=script&lang=js&"
export * from "./certificate_204.vue?vue&type=script&lang=js&"
import style0 from "./certificate_204.vue?vue&type=style&index=0&id=14b7b656&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b7b656",
  null
  
)

export default component.exports